{
	"backToManageDeclarations": "Torna a Gestisci dichiarazioni",
	"kpi": {
		"quantity": "Quantità",
		"carbonSavings": "Riduzioni di carbonio"
	},
	"downloadAllDeclarations": "Scarica tutte le dichiarazioni",
	"errors": {
		"notFound": "Progetto non trovato"
	}
}
